export default (sitemap: SitemapBuilder) =>
{
    sitemap.push([
        {
            name: '[[[Strona główna]]]',
            short: '[[[Start]]]',
            route: 'dashboard',
            icon: 'fa-light fa-house-chimney',
            children: [
                {
                    name: '[[[Profil użytkownika]]]',
                    route: 'core-account-profile',
                    icon: 'far fa-fw fa-user-circle'
                },
                {
                    name: '[[[Zmiana hasła]]]',
                    route: 'core-account-password',
                    icon: 'far fa-fw fa-toggle-on'
                },
                {
                    name: '[[[Bezpieczeństwo]]]',
                    route: 'core-account-security',
                    icon: 'far fa-fw fa-phone-laptop'
                },
                {
                    name: '[[[Dashboardy]]]',
                    route: 'core-dashboards',
                    icon: 'far fa-display-chart-up',
                    namespace: 'Ideo.Core.Common.Application.Permissions.Core',
                    auth: { all: ['DashboardsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie dashboardu]]]',
                            route: 'core-dashboards-add',
                            auth: { all: ['DashboardsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja dashboardu]]]',
                            route: 'core-dashboards-edit',
                            auth: { all: ['DashboardsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja aranżacji dashboardu]]]',
                            route: 'core-dashboards-layout',
                            auth: { all: ['DashboardsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                }
            ]
        },
        {
            name: '[[[Tryb podglądu]]]',
            visible: false,
            namespace: 'Ideo.Core.Common.Application.Permissions.Core',
            route: 'core-unimpersonate'
        },
        {
            name: '[[[System]]]',
            short: '[[[System]]]',
            icon: 'fal fa-display',
            namespace: 'Ideo.Core.Common.Application.Permissions.Core',
            children: [
                {
                    name: '[[[Administracja]]]',
                    icon: 'far fa-fw fa-folder-user',
                    children: [
                        {
                            name: '[[[Użytkownicy]]]',
                            route: 'core-users',
                            icon: 'far fa-fw fa-user',
                            auth: { all: ['UsersPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie użytkownika]]]',
                                    route: 'core-users-add',
                                    auth: { all: ['UsersPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja użytkownika]]]',
                                    route: 'core-users-edit',
                                    auth: { all: ['UsersPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Role i uprawnienia]]]',
                            route: 'core-roles',
                            icon: 'far fa-fw fa-user-shield',
                            auth: { all: ['RolesPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie roli]]]',
                                    route: 'core-roles-add',
                                    auth: { all: ['RolesPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja roli]]]',
                                    route: 'core-roles-edit',
                                    auth: { all: ['RolesPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Monitoring]]]',
                    icon: 'far fa-fw fa-analytics',
                    children: [
                        {
                            name: '[[[Historia logowania]]]',
                            route: 'core-authlog',
                            icon: 'far fa-fw fa-file-import',
                            auth: { all: ['AdminPermissions@Authlog'], any: [] }
                        },
                        {
                            name: '[[[Rejestr zmian]]]',
                            route: 'core-changelog',
                            icon: 'far fa-fw fa-file-signature',
                            auth: { all: ['AdminPermissions@Changelog'], any: [] },
                            children: [
                                {
                                    name: '[[[Szczegóły zdarzenia]]]',
                                    route: 'core-changelog-diff',
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Harmonogram zadań]]]',
                            route: 'core-scheduler',
                            icon: 'far fa-fw fa-clock',
                            auth: { all: ['SchedulerPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Historia zadania]]]',
                                    route: 'core-scheduler-history',
                                    visible: false
                                },
                                {
                                    name: '[[[Szczegóły zadania]]]',
                                    route: 'core-scheduler-details',
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Monitor kolejek]]]',
                            route: 'core-queues',
                            icon: 'far fa-fw fa-clock',
                            auth: { all: ['MessagePermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Szczegóły zadania]]]',
                                    route: 'core-queues-details',
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Ustawienia]]]',
                    icon: 'far fa-fw fa-cog',
                    children: [
                        {
                            name: '[[[Bezpieczeństwo]]]',
                            route: 'core-security',
                            icon: 'far fa-fw fa-shield-alt',
                            auth: { all: ['AdminPermissions@Security'], any: [] }
                        },
                        {
                            name: '[[[Zaufane adresy IP]]]',
                            route: 'core-trusted-ips',
                            icon: 'far fa-fw fa-shield-alt',
                            auth: { all: ['AdminPermissions@TrustedIPs'], any: [] }
                        },
                        {
                            name: '[[[ReCaptcha]]]',
                            route: 'core-recaptcha',
                            icon: 'far fa-fw fa-shield-alt',
                            auth: { all: ['AdminPermissions@Recaptcha'], any: [] }
                        },
                        {
                            name: '[[[Poczta wychodząca]]]',
                            route: 'core-mailing',
                            icon: 'fa-regular fa-envelope',
                            auth: { all: ['AdminPermissions@Mailing'], any: [] }
                        },
                        {
                            name: '[[[Monitoring aplikacji]]]',
                            route: 'core-monitoring',
                            icon: 'far fa-fw fa-shield-alt',
                            auth: { all: ['AdminPermissions@Monitoring'], any: [] }
                        },
                        {
                            name: '[[[Logowanie zdarzeń]]]',
                            route: 'core-logs',
                            icon: 'far fa-fw fa-shield-alt',
                            auth: { all: ['AdminPermissions@Logs'], any: [] },
                            children: [
                                {
                                    name: '[[[Edycja logów]]]',
                                    route: 'core-logs-edit',
                                    auth: { all: ['AdminPermissions@Logs'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: '[[[Repozytorium plików]]]',
            short: '[[[Pliki]]]',
            route: 'filemanager',
            preventCloseMenu: true,
            icon: 'fa-light fa-folder-closed',
            namespace: 'Ideo.Core.Common.Application.Permissions.Storage',
            auth: { all: ['StoragePermissions@Access'], any: [] }
        },
        {
            name: '[[[Kosz]]]',
            short: '[[[Kosz]]]',
            route: 'trash',
            preventCloseMenu: true,
            icon: 'fa-light fa-trash',
            namespace: 'Ideo.Core.Common.Application.Permissions.Core',
            auth: { all: ['TrashPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Grupa]]]',
                    route: 'trash-group',
                    visible: false
                }
            ]
        }
    ]);
};
